import axiosInstance from "./AxiosInstance";

export function createPartsInventory(data) {
  return axiosInstance.post(`/vehicle-inventory-store`, data);
}
export function updatePartsInventory(data) {
  return axiosInstance.post(`/vehicle-inventory-update`, data);
}

export function getVehicleList(data) {
  return axiosInstance.post(`/vehicle-search-list`, data);
}

export function getCatalogList(data) {
  return axiosInstance.post(`/catalog-search-list`, data);
}

export function getPartsInventoryList(data) {
  return axiosInstance.post(`/part-inventory-list`, data);
}

export function getPartInventoryDetails(data) {
  return axiosInstance.post(`/part-inventory-details`, data);
}

export function actionPartInventoryTempStore(data) {
  return axiosInstance.post(`/vehicle-inventory-temp-store`, data);
}

export function getPartInventoryTempList(data) {
  return axiosInstance.post(`/vehicle-inventory-temp-list`, data);
}

export function DestoryPartInventoryTemp(data) {
  return axiosInstance.post(`/vehicle-inventory-temp-delete`, data);
}

export function deletePartInventory(data) {
  return axiosInstance.post(`/vehicle-inventory-delete`, data);
}

export function actionPartInventoryImage(data) {
  return axiosInstance.post(`/part-images`, data);
}

export function destoryPartInventoryImage(data) {
  return axiosInstance.post(`/part-images-delete`, data);
}

export function PartInventoryImageDetails(data) {
  return axiosInstance.post(`/part-images-details`, data);
}

export function VehiclePartList(data) {
  return axiosInstance.post(`/vehicle-parts/view/list`, data);
}

export function VehiclePartQRDetails(data) {
  return axiosInstance.post(`/qr-details`, data);
}

export function getwarHouseEntityList(data) {
  return axiosInstance.post(`/warehouse-entity/entity-list`, data);
}

export function getpartInventoryQuentityDetails(data) {
  return axiosInstance.post(`/part-qty-list`, data);
}

export function deletePartInventoryHard(data) {
  return axiosInstance.post(`/part-record-status-update`, data);
}

export function partInventoryOutOfStock(data) {
  return axiosInstance.post(`/part-out-of-stock`, data);
}

export function partInventoryInStock(data) {
  return axiosInstance.post(`/part-in-stock`, data);
}

export function partInvenToryLocationUpdate(data) {
  return axiosInstance.post(`/part-qty-location-update`, data);
}

export function partVehicleProcessUpdateExpiryDate(data) {
  return axiosInstance.post(`/vehicle-process/update-expiry-date`, data);
}

export function getpartQuantityHistoryList(data) {
  return axiosInstance.post(`/part-qty-history-list`, data);
}

export function getpartQuantityList(data) {
  return axiosInstance.post(`/part-qty-list`, data);
}

export function actionPartStatusUpdate(data) {
  return axiosInstance.post(`/part-status-update`, data);
}

export function getPartVehicleLogHistory(data) {
  return axiosInstance.post(`/ler-vehicle-log/history`, data);
}

export function partInvenoryVehicleSearch(data) {
  return axiosInstance.post(`/part-vehicle-search-list`, data);
}

export function partInvenoryPartETAI(data) {
  return axiosInstance.post(`/part-etai-details`, data);
}

export function partInvenoryPartETAIPrice(data) {
  return axiosInstance.post(`/part-etai-details-price`, data);
}

export function partInvenoryPartRefDelete(data) {
  return axiosInstance.post(`/part-ref-delete`, data);
}

export function partInvenoryPartPdf(data) {
  return axiosInstance.post(`/part-list-pdf`, data);
}

export function partInvenoryAllPartPdf(data) {
  return axiosInstance.post(`/part-all-list-pdf`, data);
}

export function partInvenoryPartDelete(data) {
  return axiosInstance.post(`/part-associate-delete`, data);
}

export function partDamageDelete(data) {
  return axiosInstance.post(`/part-damage-delete`, data);
}

export function partRefDelete(data) {
  return axiosInstance.post(`/part-ref-delete`, data);
}

export function getpartDamageList(data) {
  return axiosInstance.post(`/damage-list`, data);
}

export function createPartDamageAssigned(data) {
  return axiosInstance.post(`/assign-damage`, data);
}

export function deletePartDamageAssigned(data) {
  return axiosInstance.post(`/delete-damage`, data);
}

export function createPartVideo(data) {
  return axiosInstance.post(`/part-video`, data);
}

export function updatePartVideoSort(data) {
  return axiosInstance.post(`/part-video/update-part-video-sort`, data);
}

export function deletePartvideo(data) {
  return axiosInstance.post(`/part-video-delete`, data);
}

export function getPartVideoSortDetails(data) {
  return axiosInstance.post(`/part-video-details`, data);
}

export function getCatalogModalStatsHistoryDetails(data) {
  return axiosInstance.post(`/catalog-modal-stats-history`, data);
}

export function getPartStatiscalPriceDetails(data) {
  return axiosInstance.post(`/part-statiscal-price`, data);
}

export function getPartEstimatePriceDetails(data) {
  return axiosInstance.post(`/estimate-price`, data);
}

export function getPartRefcodeConditionDetails(data) {
  return axiosInstance.post(`/get-refcode-condition-stats`, data);
}

export function createOCRreferenceRead(data) {
  return axiosInstance.post(`/part-reference-read`, data);
}

export function getPartRefAllList(data) {
  return axiosInstance.post(`/part-reference-list`, data);
}

export function createReplicatePart(data) {
  return axiosInstance.post(`/replicate-vehicle-parts`, data);
}

export function deletePartQty(data) {
  return axiosInstance.post(`/part-qty-delete`, data);
}

export function recoverPartQty(data) {
  return axiosInstance.post(`recover-part-qty`, data);
}

export function downloadPartImageZip(data) {
  return axiosInstance.post(`/download-part-images-by-vehicle`, data);
}

export function createReservesPart(data) {
  return axiosInstance.post(`/reserves-send-part-pending`, data);
}

export function getReservesPartPendingList(data) {
  return axiosInstance.post(`/reserves-pending/list`, data);
}

export function getExportPartInvenrotyList(data) {
  return axiosInstance.post(`/export-part-inventory-list`, data);
}

export function getImportPartCSVPrice(data) {
  return axiosInstance.post(`/import-csv-part-price`, data);
}

export function getMainReservesList(data) {
  return axiosInstance.post(`/reserves/list`, data);
}

export function getReservesDetails(data) {
  return axiosInstance.post(`/reserves/get-details`, data);
}

export function cancelReservesData(data) {
  return axiosInstance.post(`/reserves/cancel`, data);
}

export function ReservesSerachData(data) {
  return axiosInstance.post(`/reserves/search-list`, data);
}

export function AddReservesSendPart(data) {
  return axiosInstance.post(`/reserves-send-part`, data);
}

export function AddReservesConvertToSales(data) {
  return axiosInstance.post(`/reserves/convert-sales`, data);
}

export function getInternalSalesData(data) {
  return axiosInstance.post(`/internal-sales/list`, data);
}

export function getParentWarhouseData(data) {
  return axiosInstance.post(`/warehouse/parent-list`, data);
}

export function getStructureOem(data) {
  return axiosInstance.post(`/structure-oem`, data);
}

export function getvehicleCompatibleProduct(data) {
  return axiosInstance.post(`/get-vehicle-compatible-by-products`, data);
}

export function getvehicleProductDetails(data) {
  return axiosInstance.post(`/product-details`, data);
}

export function getVehicleCompatibleDetails(data) {
  return axiosInstance.post(`/get-vehicle-compatible-models`, data);
}

export function getRepairPartInventoryList(data) {
  return axiosInstance.post(`/repair-part-inventory-list`, data);
}

export function createRepairPartInventory(data) {
  return axiosInstance.post(`/parts-repair/create`, data);
}

export function updatePartInventoryPrice(data) {
  return axiosInstance.post(`/update-part-inventory-price`, data);
}

export function generateShoppingCartLink(data) {
  return axiosInstance.post(`/generate-shopping-cart-link`, data);
}

export function getChangePartCheckStatus(data) {
  return axiosInstance.post(`/change-parts-check-status`, data);
}

export function getPartCatalogSerachCheck(data) {
  return axiosInstance.post(`/part-check-catalog-search-list`, data);
}

export function createPartsCheckReferenceCheck(data) {
  return axiosInstance.post(`/add-parts-check-reference-verified`, data);
}

export function createPartsCheckDamage(data) {
  return axiosInstance.post(`/add-parts-check-damage-verified`, data);
}

export function getPartCheckDetails(data) {
  return axiosInstance.post(`/parts-check-details`, data);
}

export function createPartsCheckImage(data) {
  return axiosInstance.post(`/add-parts-check-images`, data);
}

export function deletePartsCheckImage(data) {
  return axiosInstance.post(`/delete-parts-check-image`, data);
}

export function createPartsCheckVideo(data) {
  return axiosInstance.post(`/add-parts-check-video`, data);
}

export function deletePartsCheckVideo(data) {
  return axiosInstance.post(`/delete-parts-check-video`, data);
}

export function getPartsByReference(data) {
  return axiosInstance.post(`/get-parts-by-reference`, data);
}

export function createConvertPart(data) {
  return axiosInstance.post(`/parts-check-convert-inventory`, data);
}

export function deletePartCatalogCheckList(data) {
  return axiosInstance.post(
    `/parts-catalog/delete-part-catalog-checklist`,
    data,
  );
}

export function getVehiclePartsChecklist(data) {
  return axiosInstance.post(
    `/vehicle-process/get-vehicle-parts-checklist`,
    data,
  );
}

export function createVehiclePartsStatuChecklist(data) {
  return axiosInstance.post(
    `/vehicle-process/change-vehicle-parts-checklist-status`,
    data,
  );
}

export function getVehiclePartsStatusHistoryChecklist(data) {
  return axiosInstance.post(
    `/vehicle-process/get-vehicle-parts-checklist-action-history`,
    data,
  );
}

export function createVehicleAddPartAssignCatalog(data) {
  return axiosInstance.post(
    `/vehicle-process/add-car-model-assign-catalog`,
    data,
  );
}

export function getVehicleAddPartAssignCatalog(data) {
  return axiosInstance.post(
    `/vehicle-process/get-car-model-assign-catalog`,
    data,
  );
}

export function createPartsByPhoto(data) {
  return axiosInstance.post(`/get-parts-by-photo`, data);
}

export function getVerifyFilterDetails(data) {
  return axiosInstance.post(`/verify-filter-details`, data);
}

export function getBrandList(data) {
  return axiosInstance.post(`/brand`, data);
}

export function getManufacterList(data) {
  return axiosInstance.post(`/manufacter`, data);
}

export function getCatalogPartsList(data) {
  return axiosInstance.post(`/parts-catalog/catalog-parts-list`, data);
}

export function getCheckVehicleAssociatePart(data) {
  return axiosInstance.post(`/check-vehicle-associate-part`, data);
}

export function getPartCatalogChecklistItems(data) {
  return axiosInstance.post(`/get-part-catalog-checklist-items`, data);
}

export function getSearchVehicleprocessList(data) {
  return axiosInstance.post(`/vehicle-process/get-search-vehicle-list`, data);
}
export function getSearchSearchManufacturerEngineList(data) {
  return axiosInstance.post(
    `/vehicle-engine/search-manufacturer-engine-list`,
    data,
  );
}

export function getSearchSearchManufacturerMotorCodeList(data) {
  return axiosInstance.post(`/vehicle-engine/search-motor-code-list`, data);
}

export function getAllPartDamageList(data) {
  return axiosInstance.post(`/get-part-damage-list`, data);
}

export function getHistoryLogList(data) {
  return axiosInstance.post(`/history-log/list`, data);
}

export function createInternalSales(data) {
  return axiosInstance.post(`/sales/create`, data);
}

export function getDismentalAllPartsCheckStatus(data) {
  return axiosInstance.post(`/dismental-all-parts-check-status`, data);
}

export function updateBulkPartInventoryPrice(data) {
  return axiosInstance.post(`/update-bulk-part-inventory-price`, data);
}

export function updateBulkPartInventoryReference(data) {
  return axiosInstance.post(`/insert-bulk-part-inventory-reference`, data);
}

